<div [ngStyle]="styleObject">
  {{ props?.text }}
</div>
